<template>
  <button :disabled="disabled"
          :class="['main-button-container', `${color}-color`, {'is-apple-device': isAppleDevice}, {'is-disabled' : disabled}]">
    <div class="main-button-content">
      <main-paragraph :font-family="!$isMobile
      ? 'Eurostile'
      : 'EurostileR'">
        <slot/>
      </main-paragraph>
    </div>
  </button>
</template>

<script>
import MainParagraph from "@/components/shared/text/MainParagraph.vue";

export default {
  name: "MainButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    isAppleDevice() {
      return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent)
    }
  },
  components: {MainParagraph}
}
</script>

<style scoped lang="scss">
  .main-button-container {
    height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    width: fit-content;
    overflow: hidden;
    cursor: pointer;
    background: var(--color-gradient);
    font-family: 'Eurostile', sans-serif;
    font-weight: 400;
    &.is-disabled {
      opacity: .6;
      cursor: default;
      &:hover {
        .main-button-content {
          background: var(--color-purple) !important;
        }
      }
    }
    &.dark-color {
      .main-button-content {
        background: var(--color-purple);
      }
      .text-content {
        font-family: 'Eurostile-R', sans-serif !important;
        color: var(--color-white);
      }


      &:hover {
        .main-button-content {
          background: var(--color-violet);
        }
      }
      &:active {
        .main-button-content {
          background: var(--color-dark-violet);
        }
      }
    }
    &.white-color {
      .main-button-content {
        background: var(--color-white);
      }
      .text-content {
        color: var(--color-dark-purple);
      }


      &:hover {
        .main-button-content {
          background: var(--color-dark-pink);
        }
      }
      &:active {
        .main-button-content {
          background: var(--color-dark-pink);
        }
      }
    }
    &.is-apple-device {
      .main-button-content {
        .text-content {
          line-height: normal !important;
        }
      }
    }
    .main-button-content {
      min-height: inherit;
      height: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background .3s ease;
      width: 100%;
      .text-content {
        line-height: 100% !important;
      }
    }


    &:hover {
      .main-button-content {
        background: var(--color-violet);
      }
    }
    &:active {
      .main-button-content {
        background: var(--color-dark-violet);
      }
    }
  }


  @media (max-width: 3024px){
    .main-button-container {
      min-height: 58px;
      .main-button-content {
        padding: 0 56px;
        .text-content {
          height: 18px;
        }
      }
    }
  }

  @media (max-width: 1920px) {
    .main-button-container {
      min-height: 47px;
      .main-button-content {
        padding: 0 40px;
        .text-content {
          height: 16px;
        }
      }
    }
  }
  @media (max-width: 1600px) {
    .main-button-container {
      min-height: 37px;
      .main-button-content {
        padding: 0 32px;
        .text-content {
          height: 14px;
        }
      }
    }
  }
  @media (max-height: 800px) {
    .main-button-container {
      min-height: 32px;
      .main-button-content {
        padding: 0 24px;
        .text-content {
          height: 12px;
        }
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .main-button-container {
      min-height: 37px;
      .main-button-content {
        padding: 0 32px;
        .text-content {
          height: 14px;
        }
      }
    }
  }

  @media (max-width: 1133px) {
    .main-button-container {
      min-height: 32px;
      .main-button-content {
        padding: 0 24px;
        .text-content {
          height: 12px;
        }
      }
    }
  }
  @media (max-width: 769px) {
    .main-button-container {
      min-height: 37px;
      .main-button-content {
        padding: 0 24px;

        .text-content {
          height: 12px;
          font-size: 12px;
        }
      }
    }
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .main-button-container {
      min-height: 95px;
      .main-button-content {
        padding: 0 72px;
        .text-content {
          height: 36px;
        }
      }
    }
  }
</style>